<template>
    <transition name="modal">
        <div class="modal" v-if="isOpen">
            <div class="modal-container">
                <button class="modal-close" @click="$emit('close')">
                    <svg viewBox="0 0 22 22">
                        <path
                            d="M0.439341 0.43934C-0.146445 1.02513 -0.146446 1.97487 0.439341 2.56066L8.64273 10.7641L0.43934 18.9674C-0.146447 19.5532 -0.146447 20.503 0.43934 21.0888C1.02513 21.6746 1.97487 21.6746 2.56066 21.0888L10.7641 12.8854L18.9674 21.0888C19.5532 21.6745 20.503 21.6745 21.0888 21.0888C21.6745 20.503 21.6745 19.5532 21.0888 18.9674L12.8854 10.7641L21.0888 2.56067C21.6745 1.97489 21.6745 1.02514 21.0888 0.439353C20.503 -0.146434 19.5532 -0.146434 18.9674 0.439353L10.7641 8.64273L2.56066 0.43934C1.97487 -0.146447 1.02513 -0.146447 0.439341 0.43934Z"
                        />
                    </svg>
                </button>
                <div class="modal-header"><slot name="header" /></div>
                <div class="modal-body "><slot name="body" /></div>
                <div class="modal-footer"><slot name="footer" /></div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Modal',
    props: ['isOpen'],
    watch: {
        isOpen: function(newVal) {
            if (newVal) document.body.classList.add('modal-open');
            else document.body.classList.remove('modal-open');
        }
    }
};
</script>

<style lang="scss" scoped>
.modal {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
    transition: all 0.3s ease-in-out;
    background: $modal-overlay-background;
    overflow: hidden;

    .modal-container {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        width: $modal-width;
        max-width: 100%;
        max-height: 100%;
        background: $modal-background;
        box-shadow: $modal-shadow;
        color: $modal-color;
        transition: all 0.3s ease-in-out;
    }

    .modal-close {
        position: absolute;
        top: -$gap;
        left: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: $gap;
        margin: 0;
        border: 0;
        color: $white;
        background: none;
        cursor: pointer;

        &:hover {
            color: darken($white, 10);
        }

        svg {
            display: block;
            width: 2.4rem;
            height: 2.4rem;

            path {
                fill: currentColor;
            }
        }
    }

    .modal-header {
        flex: 0 0 auto;
        color: $modal-header-color;
        font-size: 2.4rem;
        font-weight: bold;
        text-align: center;
        padding: $gap * 2;
    }

    .modal-body {
        flex: 1 1 auto;
        padding: 0 $gap * 2;
        overflow: hidden;
    }

    .modal-footer {
        flex: 0 0 auto;
        padding: $gap * 2;
    }

    &.modal-enter,
    &.modal-leave-active {
        opacity: 0;
    }

    &.modal-enter-active,
    &.modal-leave {
        opacity: 1;
    }

    &.modal-enter-active .modal-container,
    &.modal-leave .modal-container {
        transform: scale(0.9);
    }

    &.modal-enter .modal-container,
    &.modal-leave-active .modal-container {
        transform: scale(1.1);
    }

    @media (max-width: $mobile) {
        .modal-close {
            right: 0;
            left: initial;
            bottom: 100%;
            top: initial;
        }
    }
}
</style>
